/* eslint-disable linebreak-style */
/* eslint-disable import-newlines/enforce */
/* eslint-disable linebreak-style */

import { initializeApp, FirebaseApp } from 'firebase/app'
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging'
import { Capacitor } from '@capacitor/core'

const firebaseConfig = {
  apiKey: "AIzaSyCAXlQDywtRffYkc-cFxenaAZW6G1gTATQ",
  authDomain: "v8-abeja.firebaseapp.com",
  projectId: "abilibee-app-e06cc",
  storageBucket: "v8-abeja.firebasestorage.app",
  messagingSenderId: "922469798608",
  appId: Capacitor.isNativePlatform()
    ? Capacitor.getPlatform() === 'ios'
      ? "1:922469798608:ios:a86dc1010a4baad8bf04d5"  // iOS
      : "1:922469798608:android:a86dc1010a4baad8bf04d5"  // Android
    : "1:922469798608:web:a86dc1010a4baad8bf04d5"  // Web
}

console.log('Inicializando Firebase...')

let firebaseApp: FirebaseApp | null = null
let messaging: Messaging | null = null

export const initializeFirebase = async (): Promise<FirebaseApp> => {
  if (!firebaseApp) {
    console.log('Initializing Firebase...')
    firebaseApp = initializeApp(firebaseConfig)

    // Inicializar Messaging para todas las plataformas
    if (!Capacitor.isNativePlatform() || 'serviceWorker' in navigator) {
      console.log('Initializing Messaging...')
      messaging = getMessaging(firebaseApp)
    }
  }
  return firebaseApp
}

export const getFCMToken = async (): Promise<string | null> => {
  try {
    if (!messaging) {
      console.log('Messaging no está disponible')
      return null
    }

    console.log('Obteniendo FCM token...')
    const token = await getToken(messaging, {
      vapidKey: "BIThmWIafBQGiakQArXR0GWbSdZRnc5m7vcgbGk-hNFG1E1GvohSI7yUantZwNUI_qEG9GOkVwnbpGqfNHqTHto"
    })
    console.log('FCM token obtenido:', token)
    return token
  } catch (error) {
    console.error('Error al obtener el FCM token:', error)
    return null
  }
}

export const onMessageListener = () => {
  if (!messaging) {
    console.log('Messaging no está disponible para onMessageListener')
    return new Promise((resolve) => resolve(null))
  }

  return new Promise((resolve) => {
    if (messaging) {
      onMessage(messaging, (payload) => {
        console.log('Mensaje recibido:', payload)
        resolve(payload)
      })
    } else {
      resolve(null)
    }
  })
}

export { messaging }
